import { useTranslation } from 'react-i18next';
import { NavLink, Outlet } from 'react-router-dom';
import { applyDirection, type Language } from '../i18n.js';
import { useAuth } from '../lib/auth.js';

export function Layout(): JSX.Element {
  const { t, i18n } = useTranslation();
  const { user, isAdmin, canWrite, signOut } = useAuth();

  const toggleLanguage = async (): Promise<void> => {
    const next: Language = i18n.language === 'ar' ? 'en' : 'ar';
    await i18n.changeLanguage(next);
    applyDirection(next);
  };

  return (
    <div className="shell">
      <header className="topbar">
        <div className="brand">
          SL <span>Meetings</span>
        </div>
        <nav>
          <NavLink to="/meetings" className={({ isActive }) => (isActive ? 'active' : '')}>
            {t('nav.meetings')}
          </NavLink>
          {canWrite && (
            <NavLink to="/meetings/new" className={({ isActive }) => (isActive ? 'active' : '')}>
              {t('nav.new')}
            </NavLink>
          )}
          {isAdmin && (
            <NavLink to="/vocabulary" className={({ isActive }) => (isActive ? 'active' : '')}>
              {t('nav.vocabulary')}
            </NavLink>
          )}
        </nav>
        <button type="button" className="link" onClick={() => void toggleLanguage()}>
          {t('common.language')}
        </button>
        {user && (
          <button type="button" className="link" onClick={() => void signOut()}>
            {t('common.signOut')}
          </button>
        )}
      </header>
      <main className="page">
        <Outlet />
      </main>
    </div>
  );
}
